/* eslint-disable @typescript-eslint/no-explicit-any */

import { AnyObject } from 'types/general';

export function pick<Obj extends AnyObject, Key extends keyof Obj>(
  object: Obj,
  propsToKeep: Key[],
): Pick<Obj, Key> {
  const picked = Object.fromEntries(propsToKeep.map((prop) => [prop, object[prop]]));

  return picked as Pick<Obj, Key>;
}

export function omit<Obj extends AnyObject, Key extends keyof Obj>(
  object: Obj,
  propsToExclude: Key[],
): Omit<Obj, Key> {
  const curated = Object.fromEntries(
    Object.entries(object).filter(([prop]) => !propsToExclude.includes(prop as Key)),
  );

  return curated as Omit<Obj, Key>;
}

export function arePropertiesTruthy<Obj extends Record<string, any>>(object: Obj): boolean {
  return Object.values(object).every(Boolean);
}

export function omitUndefined<Obj extends Record<string, any>>(object: Obj): Obj {
  const curated = Object.fromEntries(
    Object.entries(object).filter(([_, value]) => value !== undefined),
  );

  return curated as Obj;
}

export function omitWithValues<Obj extends Record<string, any>>(
  object: Obj,
  values: any[] = [],
): Obj {
  const curated = Object.fromEntries(
    Object.entries(object).filter(([_, value]) => !values.includes(value)),
  );

  return curated as Obj;
}

export function getNumericObjectTotal(obj: Record<string, number>): number {
  const total = Object.values(obj).reduce((acc, next) => acc + next);

  return total;
}

export function logObject(description: string, object: Record<string, any>): void {
  // eslint-disable-next-line no-console
  console.log(description, JSON.stringify(object, null, 2));
}
